@media screen and (max-width: 850px) {
  .app-stats-items {
    flex-direction: column;
  }
  .app-stats-item-text {
    font-size: 18px;
  }
}
